import { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { Box, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import moment, { Moment } from "moment";
import { useAppDispatch } from "../../../redux/store";
import { LoadingSpinner } from "../../../components/ui/loadinSpinner";
import { getPatientDetailsDiagnosisGraphData, getPatientDiagnosisData } from "../../../redux/mis/misReducer";
import HorizontalBar from "../../../components/charts/horizontalBar";
import routesName from "../../../constants/routesName";
import { useQueries } from "@tanstack/react-query";
function MADiagnosis({
    fromDate,
    toDate,
    country,
    state,
    district,
    taluk,
    hobli,
    serviceType,
    filterApplyToggle,
    hospitalArray,
    hospitalId,
    countryid,
    stateid,
    districtid,
    talukid,
    hobliid,
    all,
}: {
    fromDate?: any;
    toDate?: any;
    country?: string;
    state?: string;
    district?: string;
    taluk?: string;
    hobli?: string;
    serviceType?: number;
    hospitalArray?: any;
    filterApplyToggle?: boolean;
    hospitalId?: number;
    countryid?: any;
    stateid?: any;
    districtid?: any;
    talukid?: any;
    hobliid?: any;
    all?: boolean
}) {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    // const diagnosisData = useSelector(
    //     (data: any) => data.getPatientDetailsDiagnosisGraphData
    // );

    const [{ data: diagnosisData, isLoading: isgraphLoading }] = useQueries({
        queries: [
            {
                queryKey: ["getDiagnosisMis", fromDate, toDate, hospitalId, countryid,
                    stateid,
                    districtid,
                    talukid,
                    hobliid, all],
                queryFn: () => getPatientDiagnosisData(fromDate, toDate, hospitalId, countryid,
                    stateid,
                    districtid,
                    talukid,
                    hobliid, all),
            },
        ],
    });

    const [errorMessage, setErrorMessage] = useState<string>("");
    const [diagnosisGraphData, setDiagnosisGraphData] = useState<any>([]);

    // interface Hospital {
    //   name: string;
    //   patientsCount: number;
    //   percentage: number;
    // }

    // let names: string[] = [];
    // let totalCount: number[] = [];
    // let percentage: number[] = [];

    // let name: string[] = [];
    // let totalCounts: number[] = [];
    // let percentages: number[] = [];

    // let othersCount: number[] = [];
    // let othersPercentage: number[] = [];

    // diagnosisGraphData?.patientDetailsSummary?.patientsCountList?.forEach(
    //   (hospital: Hospital, index: number) => {
    //     if (index < 4) {
    //       names.push(hospital.name);
    //       totalCount.push(hospital.patientsCount);
    //       percentage.push(hospital.percentage);
    //     } else {
    //       othersCount.push(hospital.patientsCount);
    //       othersPercentage.push(hospital.percentage);
    //     }
    //   }
    // );

    // const otherCount = othersCount?.reduce(
    //   (acc: number, curr?: number) => acc + (curr ?? 0),
    //   0
    // );
    // const otherPercentage = othersPercentage?.reduce(
    //   (acc: number, curr?: number) => acc + (curr ?? 0),
    //   0
    // );

    // const newObjectAtIndex5 = {
    //   name: "Others",
    //   patientsCount: otherCount,
    //   percentage: otherPercentage,
    // };

    // const index = 4;
    // const value = newObjectAtIndex5;
    // const newArr = [];
    // for (
    //   let i = 0;
    //   i < diagnosisGraphData?.patientDetailsSummary?.patientsCountList.length;
    //   i++
    // ) {
    //   if (i === index) {
    //     newArr.push(value);
    //   }
    //   newArr.push(
    //     diagnosisGraphData?.patientDetailsSummary?.patientsCountList[i]
    //   );
    // }

    // if (othersCount.length > 0) {
    //   newArr.forEach((hospital: Hospital, index: number) => {
    //     if (index < 5) {
    //       name.push(hospital.name);
    //       totalCounts.push(hospital.patientsCount);
    //       percentages.push(hospital.percentage);
    //     }
    //   });
    // }

    console.log(diagnosisData, "diagnosisData")

    const { labels, values, percentages, totalPatients } = useMemo(() => {
        if (!diagnosisGraphData || diagnosisGraphData.length === 0) {
            return { labels: [], values: [], percentages: [], totalPatients: 0 };
        }

        // Sort by count DESC
        const sorted = [...diagnosisGraphData].sort(
            (a: any, b: any) => b.revenue - a.revenue
        );

        const top5 = sorted.slice(0, 5);
        const others = sorted.slice(5);

        // const othersCountSum = others.reduce(
        //     (acc: number, curr: any) => acc + (curr.count || 0),
        //     0
        // );
        const othersCountSum = others.reduce(
            (acc: number, curr: any) => acc + (curr.revenue || 0),
            0
        );

        const totalCount = sorted.reduce(
            (acc: number, curr: any) => acc + (curr.count || 0),
            0
        );
        const total = sorted.reduce(
            (acc: number, curr: any) => acc + (curr.revenue || 0),
            0
        );

        const finalData =
            others.length > 0
                ? [
                    ...top5,
                    {
                        description: "Others",
                        count: othersCountSum,
                    },
                ]
                : top5;

        const labels = finalData.map((item: any) => item.description);
        // const values = finalData.map((item: any) => item.count);
        const values = finalData.map((item: any) =>
            Number((item.revenue)) // convert to lakhs
        );
        const percentages = finalData.map((item: any) =>
            total > 0 ? (item.revenue / total) * 100 : 0
        );

        return { labels, values, percentages, totalPatients: totalCount };
    }, [diagnosisGraphData]);
    const ctx = document.createElement("canvas").getContext("2d");
    const gradient = ctx?.createLinearGradient(0, 0, 200, 0);
    if (gradient) {
        gradient.addColorStop(0, "#D2EEE6");
        gradient.addColorStop(1, "#69C7AE");
    }

    const data = {
        labels: labels,
        datasets: [
            {
                label: "value",
                backgroundColor: gradient,
                barPercentage: 0.6,
                borderColor: "#98D9C7",
                borderWidth: 1,
                hoverBackgroundColor: gradient,
                hoverBorderColor: "#98D9C7",
                data: values,
            },
        ],
    };

    useEffect(() => {
        if (diagnosisData?.status === "success") {
            setErrorMessage("");
            setDiagnosisGraphData(diagnosisData?.data?.data ?? []);
        } else if (diagnosisData?.status === "failed") {
            setErrorMessage("Something went Wrong");
        }
    }, [diagnosisData]);

    // useEffect(() => {
    //     dispatch(
    //         getPatientDetailsDiagnosisGraphData({
    //             country: country,
    //             state: state,
    //             district: district,
    //             taluk: taluk,
    //             hobli: hobli,
    //             serviceType: serviceType,
    //             fromDate: moment(fromDate).format("YYYY-MM-DD"),
    //             toDate: moment(toDate).format("YYYY-MM-DD"),
    //             hospitals: [],
    //             hospitalId: hospitalId,

    //         })
    //     );
    // }, [filterApplyToggle, fromDate, toDate]);
    return (
        <>
            <div className="p-4 bg-white border border-gray-250 shadow-sm1 rounded-lg w-full" style={{height:!all?"":"90%"}}>
                <div className="w-full flex items-center justify-between block pb-2 border-b-[0.5px] border-opacity-50 border-dashed border-gray-450">
                    <span className="text-18 font-medium text-primary">Diagnosis</span>
                    {!all && <div className="flex items-center gap-2">
                        <div className="border-r-2 border-gray-250">
                            <button
                                type="button"
                                style={{ marginRight: "12px" }}
                                onClick={() => navigate(routesName.misDiagnosis)}
                            >
                                <span className="text-14 font-[700] capitalize text-[#534FA1]">
                                    Hospital List
                                </span>
                            </button>
                        </div>

                        <button
                            type="button"
                            onClick={() =>
                                navigate(routesName.MisGraphs, {
                                    state: { label: "Diagnosis", hospitalId: hospitalId, singleHospital: true },
                                })
                            }
                        >
                            <span className="text-14 font-[700] capitalize text-[#534FA1]">
                                View All
                            </span>
                        </button>
                    </div>}
                </div>
                {isgraphLoading ? (
                    <div className="flex justify-center items-center h-full">
                        <LoadingSpinner />
                    </div>
                ) : (
                    <>
                        {diagnosisGraphData.length > 0 ? (
                            <>
                                <div className="pt-2 flex items-center">
                                    <div className="border-r-2 border-gray-250">
                                        <span className="text-14 font-[400] text-secondary">
                                            No. of Diagnosis :
                                        </span>
                                        <span className="text-14 font-[700] text-primary pl-1 pe-2">
                                            {diagnosisGraphData?.length}
                                        </span>
                                    </div>

                                    <span className="text-14 font-[400] text-secondary ps-3">
                                        No. of patients :
                                    </span>
                                    <span className="text-14 font-[700] text-primary pl-1">
                                        {totalPatients.toLocaleString("en-IN")}

                                    </span>
                                </div>
                                {/* <Box sx={{ marginTop: "6px" }}> */}
                                <div className="h-full pb-14">
                                    <HorizontalBar
                                        data={data}
                                        percentage={percentages}
                                        title="Diagnosis"
                                    />
                                </div>

                                {/* </Box> */}
                            </>
                        ) : (
                            <>
                                <div className="flex justify-center items-center h-full">
                                    <span className="text-18 font-medium text-primary">
                                        No Data Found
                                    </span>
                                </div>
                            </>
                        )}
                    </>
                )}
            </div>
        </>
    )
}

export default MADiagnosis